import { useQuery } from "@tanstack/react-query";
import { GoalsAndTargetsApi } from "../routes/goalsAndTarget";
import { apiLogger } from "../Utils/logger";

export const useGetGoalsAndTargets = (params, enabled = true) => {
  return useQuery({
    queryKey: ["goalsAndTargets", "goals", params],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", "/user/goals");
        const response = await GoalsAndTargetsApi.getGoals(params);
        apiLogger.apiResponse("GET", "/user/goals", response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError("GET", "/user/goals", error, error.response?.status);
        throw error;
      }
    },
    enabled,
    retry: 1,
    staleTime: 0,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useGetReflections = (userGoalId, options) => {
  return useQuery({
    queryKey: ["goalsAndTargets", "reflections", userGoalId],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", `/user/goal/reflection`);
        const response = await GoalsAndTargetsApi.getReflections(userGoalId);
        apiLogger.apiResponse("GET", `/user/goal/reflection`, response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          `/user/goal/reflection`,
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    ...options,
    retry: 1,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};

export const useGetGoalsOverview = (params, enabled = true) => {
  return useQuery({
    queryKey: ["goalsAndTargets", "overview", params],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", "/user/goal/overview");
        const response = await GoalsAndTargetsApi.getGoalOverview(params);
        apiLogger.apiResponse("GET", "/user/goal/overview", response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          "/user/goal/overview",
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    enabled,
    retry: 1,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
